export default __webpack_public_path__ + "25ecdbe62fb49a1d5d7fdac141590c58.svg";